import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import { Grid, Container, Typography } from '@mui/material';
import { Button } from "@gpstrackit/react-controls";
import Alert from '@mui/material/Alert';

//Views
import CreateEditDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard';
import MenuDashboards from 'Modules/dashboard/views/.components/dashboardPanel/.components/menuDashboards';
import CreateEditGadget from 'Modules/dashboard/views/.components/dashboardPanel/.components/gadgets/.components/createEditGadget';
import MenuActions from 'Modules/dashboard/views/.components/dashboardPanel/.components/menuActions';
import DeleteDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/deleteDashboard';
import DragDropContainer from 'Modules/dashboard/views/.components/dashboardPanel/.components/dragDropContainer'
import DeleteChart from 'Modules/dashboard/views/.components/chart/.components/deleteChart';
import VidFleetClipRequestsDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/vidFleetClipRequestsDetails';
import FirmwareDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/firmwareDetails';
import LastReadingsDetail from 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails';
import MaintenanceWarningsDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/maintenanceWarningsDetails';
import ShareDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/shareDashboard';
//Actions
import {
    updateGadgetPositionDashboardPanel,
    dashboardPanelSearchRequest,
    openDashboardPanelCreateEditModal,
    updateGadgetDashboardPanel,
    clearRedux,
} from 'Redux/actions';

//Permission
import { HasPermission } from "Core/security";

//Styles
import './index.scss';

const DashboardPanel = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { changeDashboard, dashboardId } = props;

    //Local States
    const [columns, setColumns] = useState([]);
    const [dashboardList, setDashboardList] = useState([]);
    const [dashboardSelected, setDashboardSelected] = useState({});
    const [anchorDashboard, setAnchorDashboard] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const [ isEditable, setIsEditable ] = useState(true)

    //Redux States
    const { dashboard } = useSelector((state) => state.createEditDashboardRedux)
    const { createUserGadget } = useSelector((state) => state.dashboardPanelMainRedux);
    const { create, update } = useSelector(state => state.createEditDashboardRedux);
    const deleteChartOpenModal = useSelector(state => state.deleteChartRedux.openModal);
    const createEditGadgetOpenModal = useSelector((state) => state.dashboardPanelMainRedux.openCreateEdit);
    const deleteDashboardOpenModal = useSelector(state => state.deleteDashboardRedux.openModal);
    const createEditDashboardOpenModal = useSelector(state => state.createEditDashboardRedux.openModal);
    const firmwareDetailsOpenModal = useSelector(state => state.firmwareDetailsRedux.openModal);
    const vidFleetClipRequestsDetailsOpenModal = useSelector(state => state.vidFleetClipRequestsDetailsRedux.openModal);
    const lastReadingDetailsReduxOpenModal = useSelector(state => state.lastReadingDetailsRedux.openModal);
    const maintenanceWarningsDetailsOpenModal = useSelector(state => state.maintenanceWarningsDetailsRedux.openModal);
    const shareDashboardOpenModal = useSelector(state => state.shareDashboardRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const updatePositionGadget = (columns) => {
        let gadGets = [];
        columns.map(function (column, columnId) {
            column.map((item, index) => {
                gadGets.push({
                    id: item.id,
                    dashboardId: item.dashboardId,
                    name: item.name,
                    type: item.type,
                    settings: item.settings,
                    columnPanel: item.columnPanel,
                    refreshSeconds: item.refreshSeconds,
                    columnOrder: index
                });
            });
        });
        dispatch(updateGadgetPositionDashboardPanel({ gadGets }));
    }

    const getData = (gadGet) => {
        if (gadGet.hasOwnProperty('id')) {
            let newColumns = columns[0].map((newGadget) => {
                if (newGadget.id == gadGet.id) return gadGet
                else return newGadget
            })
            setColumns([newColumns])
        }
    }

    const onDragEnd = (result, columns, setColumns) => {
        if (!result.destination) return;
        const { source, destination } = result;
        const [removed] = columns[source.droppableId].splice(source.index, 1);
        columns[destination.droppableId].splice(destination.index, 0, removed);
        setColumns(columns);
        updatePositionGadget(columns);
    };

    const createEdit = (gadGet) => {
        let gadGetEdit;
        columns.map(function (column, columnId) {
            column.map((item, index) => {
                if (item.id === gadGet.id) gadGetEdit = { ...item, columnOrder: index };
            });
        });
        dispatch(openDashboardPanelCreateEditModal(true, gadGetEdit));
    }

    const expandGadget = (item) => {
        let columnPanel = (item.columnPanel !== 2) ? 2 : 1;
        let newColumns = [];
        columns.map(function (column, columnId) {
            column.map((items, index) => {
                if (items.id === item.id) {
                    newColumns.push({
                        ...items,
                        columnPanel
                    })
                } else newColumns.push(items)
            });
        });
        setColumns([newColumns])
        dispatch(updateGadgetDashboardPanel({
            id: item.id,
            dashboardId: item.dashboardId,
            name: item.name,
            type: item.type,
            settings: item.settings,
            columnOrder: item.columnOrder,
            refreshSeconds: item.refreshSeconds,
            columnPanel
        }));
    }

    const renameDashboard = (newName) => {
        setDashboardSelected({ ...dashboardSelected, name: newName, gadgets: columns[0] })
        let items = [];
        dashboardList.map((dashboardItem) => {
            let value = { ...dashboardItem };
            if (dashboardItem?.id == dashboardSelected?.id) value.name = newName;
            items.push(value);
        });
        setDashboardList(items);
    }

    const deleteGadget = (gadGet) => {
        let newColumns = columns[0].filter(column => column.id !== gadGet.id)
        setColumns([newColumns]);
        NotificationManager.success(
            messages['drap_drop_container_success_message'],
            messages['drap_drop_container_delete_gadget'],
            4000
        );
    }

    useEffect(() => {
        dispatch(dashboardPanelSearchRequest())
    }, [])

    useEffect(() => {
        if (dashboard && dashboard?.length) {
            setDashboardList(dashboard);
        }
    }, [dashboard])

    useEffect(() => {
        if (dashboardList?.length) {
            if (dashboardId) {
                let id = dashboardId
                if (create?.id) {
                    id = create?.id
                    dispatch(clearRedux("DASHBOARD_PANEL_CREATE_EDIT", { create: null }))
                }
                if (update?.id) {
                    id = update?.id
                    dispatch(clearRedux("DASHBOARD_PANEL_CREATE_EDIT", { update: null }))
                }
                let currentDashboard = dashboardList.find((item) => item.id == id)
                if (!currentDashboard) {
                    currentDashboard = dashboardList[0]
                    changeDashboard(dashboardList[0].id)
                }
                setDashboardSelected(currentDashboard)
            } else {
                changeDashboard(dashboardList[0].id)
                setDashboardSelected(dashboardList[0])
            }
        }
    }, [dashboardList])

    useEffect(() => {
        if (dashboardSelected?.hasOwnProperty('gadgets')) {
            let gadGetsItems = dashboardSelected?.gadgets.slice().sort((a, b) => a.columnOrder > b.columnOrder ? 1 : -1);
            let items = [];
            let columnItems = [];
            gadGetsItems.map(function (gadget) {
                items.push({ ...gadget });
            });
            columnItems.push(items);
            setColumns(columnItems);
        }
    }, [dashboardSelected]);

    useEffect(() => {
        if (createUserGadget && createUserGadget.hasOwnProperty('id')) {
            let newColumns = columns[0];
            if (newColumns) {
                newColumns.unshift({ ...createUserGadget });
                setColumns([newColumns]);
                updatePositionGadget([newColumns]);
            }
            dispatch(dashboardPanelSearchRequest())
            dispatch(clearRedux("DASHBOARD_PANEL_MAIN", { createUserGadget: null }));
        }
    }, [createUserGadget]);

    useEffect(() => {
        if (dashboardSelected && dashboardSelected.shared && user) {
            let users = JSON.parse(dashboardSelected.sharedWith)
            let permissionValidate = users.find((item) => item?.id === user?.authId)
            if (permissionValidate?.id) {
                if (permissionValidate.permission === "r") {
                    setIsEditable(false)
                } else if (permissionValidate.permission === "u") {
                    setIsEditable(true)
                }
            }
        }else {
            setIsEditable(true)
        }
    }, [dashboardSelected])

    return (
        <Container maxWidth={false} className="dashboard-panel">
            <Grid container direction="row" className="dashboard-panel-container" justifyContent="space-between" alignItems='center'>
                <Grid
                    container
                    item
                    direction="row"
                    xs={12}
                    sm={6}
                    className="dashboard-panel-header"
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item>
                            <MenuDashboards
                                dashboards={dashboardList}
                                setDashboardSelected={setDashboardSelected}
                                changeDashboard={changeDashboard}
                            />
                        </Grid>
                        <Typography className="dashboard-panel-title">
                            {dashboardSelected?.name || ''}
                        </Typography>
                        {editMode &&
                            <>
                                <Button
                                    type="icon"
                                    icon="more_vert"
                                    placement="bottom"
                                    onClick={(event) => setAnchorDashboard(event.currentTarget)}
                                />
                                <Grid item>
                                    <Button
                                        type="icon"
                                        icon="add_box"
                                        placement="bottom"
                                        tooltip={messages['dashboardPanel_add_gadget']}
                                        onClick={(e) => {
                                            dispatch(openDashboardPanelCreateEditModal(true))
                                        }}
                                    />
                                </Grid>
                            </>
                        }
                        <MenuActions
                            anchorDashboard={anchorDashboard}
                            setAnchorDashboard={setAnchorDashboard}
                            dashboards={dashboardList}
                            dashboardSelected={dashboardSelected}
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12} sm={6} className="text-right" alignItems="center" >
                    <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start" className="dashboard-panel-buttons">
                        <Grid item>
                            {!editMode && isEditable &&
                                <Button onClick={(e) => setEditMode(true)} className="btn-dark-blue" disabled={(!HasPermission(user, "pmdash", "c") && !HasPermission(user, "pmdash", "u"))}>
                                    {messages['edit']}
                                </Button>
                            }
                            {editMode &&
                                <Button
                                    onClick={(e) => setEditMode(false)} className="btn-dark-blue">
                                    {messages['save']}
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {editMode && <Alert severity="info" className="dashboard-panel-alert">{messages['dashboardPanel_edit_info']}</Alert>}
            <DragDropContainer
                dashboardSelected={dashboardSelected}
                columns={columns}
                createEdit={createEdit}
                editMode={editMode}
                expandGadget={expandGadget}
                deleteGadget={deleteGadget}
                windowDimensions={windowDimensions}
                setColumns={setColumns}
                setEditMode={setEditMode}
                onDragEnd={onDragEnd}
                user={user}
                isEditable={isEditable}
            />
            {createEditDashboardOpenModal && <CreateEditDashboard
                callback={renameDashboard}
                setDashboardSelected={setDashboardSelected}
                changeDashboard={changeDashboard}
                createEdit={createEdit}
            />}
            <CreateEditGadget dashboardId={dashboardId} callback={getData} />
            {deleteDashboardOpenModal && <DeleteDashboard setDashboardSelected={setDashboardSelected} setEditMode={setEditMode} />}
            {deleteChartOpenModal && <DeleteChart />}
            {vidFleetClipRequestsDetailsOpenModal && <VidFleetClipRequestsDetails />}
            {firmwareDetailsOpenModal && <FirmwareDetails />}
            {lastReadingDetailsReduxOpenModal && <LastReadingsDetail />}
            {maintenanceWarningsDetailsOpenModal && <MaintenanceWarningsDetails />}
            {shareDashboardOpenModal && <ShareDashboard />}
        </Container>
    )
}

export default DashboardPanel